module.exports = __webpack_public_path__ + "static/img/home_banana_move.002bc94.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/home_banana_move.png
// module id = Fom/
// module chunks = 0